"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Download = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("title", null, "A2CE90A4-8AFD-4B39-8257-DE7403EDAA49"), _react.default.createElement("path", {
  d: "M9.848 12.23l-1.033 1.04V8.795a.8.8 0 00-1.601 0v4.475L6.18 12.23a.804.804 0 00-1.137 1.136l2.402 2.402a.8.8 0 00.264.168.753.753 0 00.609 0 .8.8 0 00.264-.168l2.402-2.402a.804.804 0 10-1.137-1.137zm3.307-8.862A5.606 5.606 0 002.457 4.88a3.202 3.202 0 00.753 6.316.8.8 0 100-1.601 1.601 1.601 0 110-3.202.8.8 0 00.8-.8 4.003 4.003 0 017.792-1.29.8.8 0 00.625.537 2.402 2.402 0 01.192 4.675.802.802 0 10.4 1.553 4.003 4.003 0 00.136-7.701z",
  fill: "#ACB3BE",
  fillRule: "nonzero",
  className: "fill"
}));

var _default = Download;
exports.default = _default;